module.exports = __webpack_public_path__ + "static/media/bg_01.ed42c3f3.png";